import React from "react";
import { Checkbox, Col, Row, Select, Tooltip } from "antd";
import { Option } from "antd/es/mentions";
import { useTranslation } from "react-i18next";
import InputText from "../Input/InputText";
import EditorText from "../EditorText";
import "../../../assets/style/modalStyle/postNews.scss";
import LabelInput from "../LabelInput";
import { DatePicker } from "antd";
import moment from "moment";
import { useSelector } from "react-redux";
import { dealSelector, pupSelector } from "../../../services/selector/index.";
import { deleteGroupTime } from "../../../services/slice/DealSlice";
import { useDispatch } from "react-redux";
import { setOpenPUDelete } from "../../../services/slice/PopUpSlice";
import UpImageEdit from "../Button/UpImageEdit";
import { useState } from "react";
import { useEffect } from "react";
import TranslateText from "../TranslateText";
import ModalDelete from "../Modal/delete/ModalDelete";
import ModalSelectGroupCustomer from "../Modal/other/ModalSelectGroupCustomer";
import { IconEdit, IconPen } from "../../../assets/icon";
const TabAddChatBkavPro = ({
  datapost,
  setDataPost,
  setImage,
  error,
  img,
  addPost,
}) => {
  const statePup = useSelector(pupSelector);
  const { dataDelete } = statePup;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isEdit, setIsEdit] = useState(false);
  const [showSelectGroup, setShowSelectGroup] = useState(false);
  const [valueSelectUsed, setValueSelectUsed] = useState([]);
  const [valueSelectValid, setValueSelectValid] = useState([]);
  const [valueSelectExpired, setValueSelectExpired] = useState([]);
  const [valueSelectNumberMachine, setValueSelectNumberMachine] = useState([]);
  useEffect(() => {
    if (datapost.title) {
      setIsEdit(true);
    }
  }, []);
  const dateFormat = "YYYY-MM-DD HH:mm:ss";
  useEffect(() => {
    let arrUse = [];
    let arrValid = [];
    let arrExpired = [];
    let arrNumberMachine = [];
    if (datapost?.attractGroupDetail?.length) {
      datapost?.attractGroupDetail.map((item) => {
        if (item.typeGroup === 1) {
          arrUse.push(item.id);
        } else if (item.typeGroup === 2) {
          arrValid.push(item.id);
        } else if (item.typeGroup === 3) {
          arrExpired.push(item.id);
        } else arrNumberMachine.push(item.id);
        setValueSelectExpired(arrExpired);
        setValueSelectNumberMachine(arrNumberMachine);
        setValueSelectUsed(arrUse);
        setValueSelectValid(arrValid);
      });
    }
  }, [datapost?.attractGroupDetail, datapost?.attractGroupDetail?.length]);

  const handleDelete = () => {
    dispatch(deleteGroupTime(dataDelete.id));
    dispatch(
      setOpenPUDelete({
        stateOpen: false,
        content: "",
        id: "",
      })
    );
  };

  return (
    <>
      {showSelectGroup ? (
        <ModalSelectGroupCustomer
          valueSelectExpired={valueSelectExpired}
          valueSelectNumberMachine={valueSelectNumberMachine}
          setValueSelectExpired={setValueSelectExpired}
          setValueSelectNumberMachine={setValueSelectNumberMachine}
          setValueSelectUsed={setValueSelectUsed}
          setValueSelectValid={setValueSelectValid}
          valueSelectUsed={valueSelectUsed}
          valueSelectValid={valueSelectValid}
          setDataPost={setDataPost}
          open={showSelectGroup}
          setOpen={setShowSelectGroup}
        />
      ) : null}
      
      {dataDelete.isOpenPUDelete && (
        <ModalDelete
          handleDelete={handleDelete}
          textDisable="Bạn có đồng ý xóa nhóm"
          title="Xóa nhóm"
          width={680}
        />
      )}
      {/* Tên tin nhắn */}
      <Row align={"middle"}>
        <Col span={3}>
          <LabelInput text={"Tên tin nhắn"} />
        </Col>
        <Col span={21}>
          <InputText
            maxLength={155}
            focus
            key={"inputTitle"}
            text={datapost.title}
            setText={(value) => setDataPost({ ...datapost, title: value })}
            placeholder={"Nhập tên tin nhắn"}
            typeInput={`${
              !datapost.title && error.isError ? "checkEmptyText" : null
            }`}
          />
        </Col>
      </Row>
      {/* Nội dung tin nhắn */}
      <Row
        style={{
          //   marginBottom: "1.5rem",
          margin: "1.5rem 0",
          display: "flex",
          alignItems: datapost.typePost === 1,
        }}
      >
        <Col span={3}>
          <LabelInput
            text={
              datapost.typePost === 1 ? "Nội dung tin nhắn" : "Link bài viết"
            }
          />
        </Col>
        <Col span={21}>
          {datapost.typePost === 1 ? (
            <EditorText
              text={datapost.content}
              height={180}
              placeholder={"Nhập nội dung tin nhắn"}
              setText={setDataPost}
              type={`${
                (!datapost.content || datapost.content === "<p><br></p>") &&
                error.isError
                  ? "checkEmptyText"
                  : null
              }`}
            />
          ) : (
            <InputText
              text={datapost.content}
              setText={(value) => setDataPost({ ...datapost, content: value })}
              placeholder={"Nhập đường dẫn bài viết"}
              typeInput={`${
                (!datapost.content && error.isError) ||
                error.msg === "Đường dẫn không hợp lệ"
                  ? "checkEmptyText"
                  : null
              }`}
            />
          )}
        </Col>
      </Row>
      {/* Đặt lịch gửi */}
      <Row
        style={{ margin: "1.5rem 0", display: "flex", alignItems: "center" }}
      >
        <Col span={3}>
          <LabelInput text={"Đặt lịch gửi"}></LabelInput>
        </Col>
        <Col span={21}>
          <Row style={{ display: "flex", alignItems: "center" }}>
            <Col span={13}>
              <Row style={{ display: "flex", alignItems: "center" }}>
                {" "}
                <Col span={6}>
                  <LabelInput
                    text={"Thời gian bắt đầu"}
                    style={{ textAlign: "start" }}
                  />
                </Col>
                <Col span={17}>
                  <DatePicker
                    format={"DD/MM/YYYY HH:mm:59"}
                    // value={datapost.timeEnd}
                    placeholder={t("Chọn thời gian")}
                    defaultValue={
                      datapost.timeEnd
                        ? moment(datapost.timeEnd, dateFormat)
                        : null
                    }
                    style={
                      (!datapost.timeEnd ||
                        error.msg ===
                          "Thời gian bắt đầu phải nhỏ hơn Thời gian kết thúc") &&
                      error.isError
                        ? { border: "1px solid red", width: "100%" }
                        : { width: "100%" }
                    }
                    showTime
                    onChange={(value, date) => {
                      setDataPost({
                        ...datapost,
                        timeEnd: value.format("YYYY-MM-DD HH:mm:ss"),
                      });
                    }}
                  />
                </Col>
              </Row>
            </Col>
            <Col span={11}>
              <Row
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Col span={7}>
                  <LabelInput
                    text={"Đối tượng hiển thị"}
                    style={{ textAlign: "start" }}
                  />
                </Col>
                <Col span={14}>
                  {/* <Select
                    className="base"
                    style={
                      error.msg ===
                        "Nhóm khách hàng nhận ưu đãi không xác định" &&
                      error.isError
                        ? { border: "1px solid red", width: "100%" }
                        : { width: "100%" }
                    }
                    defaultValue={0}
                    value={datapost.typePreferential}
                    onChange={(value) => {
                      if (value === 0) {
                        setValueSelectUsed([]);
                        setValueSelectValid([]);
                        return setDataPost({
                          ...datapost,
                          attractGroup: [],
                          typePreferential: value,
                        });
                      }
                      setDataPost({ ...datapost, typePreferential: value });
                    }}
                  >
                    <Option value={0}>
                      <span
                        style={{
                          width: "100%",
                          display: "flex",
                          overflow: "hidden",
                        }}
                        className="labelSelect"
                      >
                        Toàn bộ KH
                      </span>
                    </Option>
                    <Option value={1}>
                      <span
                        style={{
                          width: "100%",
                          display: "flex",
                          overflow: "hidden",
                        }}
                        className="labelSelect"
                        // onClick={() => setShowSelectGroup(true)}
                      >
                        KH thuộc đại lý
                      </span>
                    </Option>
                    <Option value={2}>
                      <span
                        style={{
                          width: "100%",
                          display: "flex",
                          overflow: "hidden",
                        }}
                        className="labelSelect"
                        // onClick={() => setShowSelectGroup(true)}
                      >
                        KH Online
                      </span>
                    </Option>
                    <Option value={3}>
                      <span
                        style={{
                          width: "100%",
                          display: "flex",
                          overflow: "hidden",
                        }}
                        className="labelSelect"
                        // onClick={() => setShowSelectGroup(true)}
                      >
                        KH Không bản quyền
                      </span>
                    </Option>
                  </Select> */}
                  <Select
                    className="base"
                    style={
                      error.msg ===
                        "Nhóm khách hàng nhận ưu đãi không xác định" &&
                      error.isError
                        ? { border: "1px solid red", width: "100%" }
                        : { width: "100%" }
                    }
                    defaultValue={0}
                    value={datapost.displayRange}
                    onChange={(value) => {
                      if (value === 0) {
                        setValueSelectUsed([]);
                        setValueSelectValid([]);
                        return setDataPost({
                          ...datapost,
                          attractGroup: [],
                          displayRange: value,
                        });
                      } else {
                        setShowSelectGroup(true);
                        setDataPost({ ...datapost, displayRange: value });
                      }
                    }}
                  >
                    <Option value={0}>
                      <span
                        style={{
                          width: "100%",
                          display: "flex",
                          overflow: "hidden",
                        }}
                        className="labelSelect"
                      >
                        Toàn bộ KH
                      </span>
                    </Option>
                    {datapost.typePreferential !== 3 ? (
                      <Option value={1}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            flexGrow: 1,
                            alignItems: "center",
                          }}
                        >
                          <span
                            style={{
                              width: "100%",
                              display: "flex",
                              overflow: "hidden",
                            }}
                            className="labelSelect"
                          >
                            Nhóm
                          </span>
                          <IconEdit onClick={() => setShowSelectGroup(true)} />
                        </div>
                      </Option>
                    ) : null}
                  </Select>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row style={{ display: "flex" }}>
        <Col span={3}></Col>
        <Col span={21}>
          <Row style={{ display: "flex" }}>
            <Col span={13}>
              {" "}
              <Row style={{ display: "flex", alignItems: "center" }}>
                {" "}
                <Col span={6}>
                  <LabelInput
                    text={"Thời gian kết thúc"}
                    style={{ textAlign: "start" }}
                  />
                </Col>
                <Col span={17}>
                  <DatePicker
                    format={"DD/MM/YYYY HH:mm:59"}
                    // value={datapost.timeEnd}
                    placeholder={t("Chọn thời gian")}
                    defaultValue={
                      datapost.timeEnd
                        ? moment(datapost.timeEnd, dateFormat)
                        : null
                    }
                    style={
                      (!datapost.timeEnd ||
                        error.msg ===
                          "Thời gian bắt đầu phải nhỏ hơn Thời gian kết thúc") &&
                      error.isError
                        ? { border: "1px solid red", width: "100%" }
                        : { width: "100%" }
                    }
                    showTime
                    onChange={(value, date) => {
                      setDataPost({
                        ...datapost,
                        timeEnd: value.format("YYYY-MM-DD HH:mm:ss"),
                      });
                    }}
                  />
                </Col>
              </Row>
            </Col>
            <Col span={11}>
              {datapost.displayRange ? (
                <>
                  <Row
                    style={{ width: "100%" }}
                    align={"middle"}
                    justify={"space-between"}
                  >
                    <Col span={10}>
                      <LabelInput text={"Số lượng"} />
                    </Col>
                    <Col span={14}>
                      <InputText
                        focus
                        width="100%"
                        typeInput={`${
                          error.msg ===
                          "Bạn nhập sai định dạng. Vui lòng nhập lại"
                            ? "checkEmptyText baseInput"
                            : "baseInput"
                        }`}
                        text={datapost.numberCustomer}
                        placeholder="Nhập số lượng KH nhận thông báo"
                        setText={(value) =>
                          setDataPost({ ...datapost, numberCustomer: value })
                        }
                      />
                    </Col>
                  </Row>
                  <Row
                    style={{ width: "100%" }}
                    align={"middle"}
                    justify={"space-between"}
                  >
                    <Col span={6}></Col>
                    <Col span={18}>
                      <i className="note">
                        (
                        {t(
                          "Nếu không nhập số lượng thì thông báo sẽ gửi cho tất cả khách hàng trong nhóm"
                        )}
                        )
                      </i>
                    </Col>
                  </Row>
                </>
              ) : null}
            </Col>
          </Row>
        </Col>
      </Row>
      {error.isError ? (
        <small className="msgError">{t(error.msg)}</small>
      ) : null}
    </>
  );
};

export default TabAddChatBkavPro;
